package org.example.project.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.ui.EditorNavigationState
import org.example.project.ui.icons.AppIcons
import org.example.project.ui.theme.EditorColors

@Composable
fun EditorSidebar(
    navState: EditorNavigationState,
    onNavigateToList: () -> Unit,
    onNavigateToNew: () -> Unit,
    onNavigateToPlanner: (() -> Unit)? = null,
    isMobileDrawer: Boolean = false,
    onCloseDrawer: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    Surface(
        modifier = modifier
            .then(if (isMobileDrawer) Modifier.fillMaxWidth() else Modifier.width(240.dp).fillMaxHeight()),
        color = EditorColors.Surface,
        border = BorderStroke(1.dp, EditorColors.BorderSubtle)
    ) {
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .padding(20.dp),
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            // Top Section: Logo & Nav items
            Column {
                // Brand Header
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.padding(bottom = 24.dp)
                ) {
                    Surface(
                        shape = RoundedCornerShape(10.dp),
                        color = EditorColors.Primary,
                        modifier = Modifier.size(36.dp)
                    ) {
                        Box(contentAlignment = Alignment.Center) {
                            Text(
                                text = "AA",
                                color = EditorColors.Surface,
                                fontSize = 14.sp,
                                fontWeight = FontWeight.ExtraBold
                            )
                        }
                    }

                    Spacer(modifier = Modifier.width(12.dp))

                    Column {
                        Text(
                            text = "ApkaAnimacyjna",
                            color = EditorColors.TextPrimary,
                            fontWeight = FontWeight.Bold,
                            fontSize = 15.sp
                        )
                        Text(
                            text = "Katalog Zabaw",
                            color = EditorColors.TextMuted,
                            fontSize = 11.sp,
                            fontWeight = FontWeight.Medium
                        )
                    }
                }

                Text(
                    text = "MENU GŁÓWNE",
                    fontSize = 11.sp,
                    fontWeight = FontWeight.Bold,
                    color = EditorColors.TextMuted,
                    letterSpacing = 0.5.sp,
                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 8.dp)
                )

                Spacer(modifier = Modifier.height(4.dp))

                // Nav Item 1: Katalog zabaw
                val isListActive = navState is EditorNavigationState.ActivityList
                SidebarNavItem(
                    label = "Katalog zabaw",
                    icon = AppIcons.Catalog,
                    selected = isListActive,
                    onClick = {
                        onNavigateToList()
                        if (isMobileDrawer && onCloseDrawer != null) onCloseDrawer()
                    }
                )

                Spacer(modifier = Modifier.height(4.dp))

                // Nav Item 2: Nowa zabawa
                val isNewActive = navState is EditorNavigationState.ActivityForm && navState.editingActivity == null
                SidebarNavItem(
                    label = "Nowa zabawa",
                    icon = AppIcons.Add,
                    selected = isNewActive,
                    onClick = {
                        onNavigateToNew()
                        if (isMobileDrawer && onCloseDrawer != null) onCloseDrawer()
                    }
                )

                if (onNavigateToPlanner != null) {
                    Spacer(modifier = Modifier.height(4.dp))
                    val isPlannerActive = navState is EditorNavigationState.Planner
                    SidebarNavItem(
                        label = "Planer eventów",
                        icon = AppIcons.Planner,
                        selected = isPlannerActive,
                        onClick = {
                            onNavigateToPlanner()
                            if (isMobileDrawer && onCloseDrawer != null) onCloseDrawer()
                        }
                    )
                }
            }

            // Bottom Section: Editorial workspace info
            Surface(
                shape = RoundedCornerShape(10.dp),
                color = EditorColors.SurfaceSubtle,
                border = BorderStroke(1.dp, EditorColors.BorderSubtle),
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(modifier = Modifier.padding(12.dp)) {
                    Text(
                        text = "Przestrzeń redakcyjna",
                        fontSize = 11.sp,
                        fontWeight = FontWeight.SemiBold,
                        color = EditorColors.TextSecondary
                    )
                    Spacer(modifier = Modifier.height(4.dp))
                    Text(
                        text = "catalog.activities.manage",
                        fontSize = 10.sp,
                        color = EditorColors.TextMuted
                    )
                }
            }
        }
    }
}

@Composable
private fun SidebarNavItem(
    label: String,
    icon: ImageVector,
    selected: Boolean,
    onClick: () -> Unit
) {
    val bgColor = if (selected) EditorColors.PrimarySubtle else EditorColors.Surface
    val contentColor = if (selected) EditorColors.Primary else EditorColors.TextSecondary
    val fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium

    Surface(
        shape = RoundedCornerShape(10.dp),
        color = bgColor,
        modifier = Modifier
            .fillMaxWidth()
            .clickable { onClick() }
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                imageVector = icon,
                contentDescription = null,
                tint = contentColor,
                modifier = Modifier.size(18.dp)
            )
            Spacer(modifier = Modifier.width(10.dp))
            Text(
                text = label,
                fontSize = 13.sp,
                fontWeight = fontWeight,
                color = contentColor
            )
        }
    }
}
